import * as React from 'react';
import { Container } from './styles.js';

const Card = ({ containerRef , children , defaultHoverBehavior , className , elevated , onClick , highlight , borderColor , loading , hasError , testId  })=>/*#__PURE__*/ React.createElement(Container, {
        "data-testid": testId ?? "card",
        ref: containerRef,
        className: className,
        defaultHover: defaultHoverBehavior,
        elevated: elevated,
        onClick: onClick,
        highlight: highlight,
        borderColor: borderColor,
        $loading: loading,
        hasError: hasError
    }, children);

export { Card };
